import { useQuery } from '@tanstack/react-query';
import { DashboardService } from 'api/services/DashboardService';
import type { WorkboardTaskApiEvent } from 'dashboard409a/components/ModelsCalendar/ModelsCalendar.types';

export const WORKBOARD_TASK_CALENDAR_EVENTS_QUERY_KEY = 'workboard-task-calendar-events';

const normalizeWorkboardTaskCalendarEventsResponse = (
  response: Awaited<ReturnType<typeof DashboardService.apiDashboardWorkboardTasksCalendarEventsList>>
): WorkboardTaskApiEvent[] => {
  const normalized = response as { events?: WorkboardTaskApiEvent[] } | WorkboardTaskApiEvent[];
  return Array.isArray(normalized) ? normalized : (normalized.events ?? []);
};

const fetchWorkboardTaskCalendarEvents = async (
  timeMin: string,
  timeMax: string,
  userIds: number[]
) => {
  const response = await DashboardService.apiDashboardWorkboardTasksCalendarEventsList(
    timeMin,
    timeMax,
    userIds.length > 0 ? userIds : undefined
  );
  return normalizeWorkboardTaskCalendarEventsResponse(response);
};

const useWorkboardTaskCalendarEvents = (
  timeMin: string,
  timeMax: string,
  userIds: number[] = []
) =>
  useQuery({
    queryKey: [
      WORKBOARD_TASK_CALENDAR_EVENTS_QUERY_KEY,
      timeMin,
      timeMax,
      [...userIds].sort((a, b) => a - b),
    ],
    queryFn: () => fetchWorkboardTaskCalendarEvents(timeMin, timeMax, userIds),
    refetchOnWindowFocus: false,
  });

export default useWorkboardTaskCalendarEvents;
